module.exports = __webpack_public_path__ + "img/p15.d71de994.png";